export var PickType;
(function (PickType) {
    PickType[PickType["SALES_ORDER_PICK"] = 1] = "SALES_ORDER_PICK";
    PickType[PickType["MANUFACTURING_PICK"] = 2] = "MANUFACTURING_PICK";
    PickType[PickType["TRANSFER_ORDER_PICK"] = 3] = "TRANSFER_ORDER_PICK";
})(PickType || (PickType = {}));
//# sourceMappingURL=pick-type.js.map